import axios from "axios";
import { MxUtils } from "../utils/mxutils";
import { store } from "../store/index";

const api = axios.create({
	baseURL: process.env.REACT_APP_SERVICES_HOST,
	timeout: 600 * 1000, // 10 minuto
});

const localApi = axios.create({
	baseURL: process.env.REACT_APP_LOCALHOST,

	timeout: 600 * 1000, // 10 minuto
});

const inventarioApi = axios.create({
	baseURL: process.env.REACT_APP_COLETOR_INVENTARIO,
	timeout: 600 * 1000, // 10 minuto
});

const armazemApi = axios.create({
	baseURL: process.env.REACT_APP_COLETOR_ARMAZEM_SERVICE,
	timeout: 600 * 1000, // 10 minuto
});

const solServiceApi = axios.create({
	baseURL: process.env.REACT_APP_SOL_SERVICE,
	timeout: 600 * 1000, // 10 minuto
});

const integracaoCargoSnapApi = axios.create({
	baseURL: process.env.REACT_APP_INTEGRACAO_CARGOSNAP_SERVICE,
	timeout: 600 * 1000, //10 minuto
});

usarTokenMx(api, inventarioApi, localApi, armazemApi, solServiceApi, integracaoCargoSnapApi);

export { localApi, inventarioApi, armazemApi, solServiceApi, integracaoCargoSnapApi };
export default api;

/**
 * @description Adiciona o um interceptador das requisições daquela instância para token do usuário no header da requisição
 *
 * @typedef {import("axios").AxiosInstance} instancia
 * @param {instancia[]} args Lista de instâncias
 * @returns {void} Configura um interceptador de requisições para usar o token do usuário
 */
function usarTokenMx(...args) {
	args.forEach((instancia) => {
		instancia.interceptors.request.use(configurarToken, (error) => {
			console.log(error);
			// I cand handle a request with errors here
			return Promise.reject(error);
		});
	});
}

/**
 * @description Adiciona o token do usuário no header da configuração da requisição do axios
 * @param {import("axios").AxiosRequestConfig} config
 * @returns Uma configuração de requisição com o token do usuário
 */
async function configurarToken(config) {
	if (
		!config ||
		(config?.url ?? "").endsWith("usuario/autenticar") ||
		(config?.url ?? "").endsWith("usuario/atualizar")
	)
		return config;

	// Caso a data do token tenha expirado a rotina irá verificar o token para qualquer requisição menos para os links acima
	const dataExpiracaoToken = MxUtils.getDataExpiracaoToken();
	const dataAtual = MxUtils.getDataAtual();

	if (dataAtual > dataExpiracaoToken) {
		// refresh the token here
		try {
			let state = store.getState();
			let terminal = state.loginreducer.Terminal;
			await MxUtils.atualizaToken("terminalid", terminal);
		} catch {
			MxUtils.limparStorageLogin();
		}
	}
	const userToken = MxUtils.getToken();
	if (userToken) {
		config.headers.Authorization = `Bearer ${userToken}`;
	}

	return config;
}
